import React, { useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Typography,
  Button,
  Select,
  message,
  Divider,
  Popconfirm,
} from "antd";
import { Colors } from "theme";
import EmptyState from "./EmptyState";
import Table from "./Table";
import { WarningFilled } from "@ant-design/icons";
const { Title, Text } = Typography;
export default function Variant({
  showVariantModal,
  handleOkVaraint,
  handleCancelVariant,
  attributes,
  formData,
  productId,
}) {
  const [attrs, setAttrs] = useState([]);
  const [selectedAttrs, setSelectedAttrs] = useState([]);
  const [variant, setVariant] = useState([]);
  const [dataSource, setDataSource] = useState([{}]);
  const [variantsData, setVariantsData] = useState([]);
  const [priceAttrs, setPriceAttrs] = useState([]);
  const [sizeAttrs, setSizeAttrs] = useState([]);
  const [currency, setCurrency] = useState("USD");
  const [unit, setUnit] = useState("per-piece");
  const [sizeUnit, setSizeUnit] = useState("inches");
  const [attrsNames, setAttrsNames] = useState([]);

  useEffect(() => {
    if (formData?.variants?.length > 0) {
      const attributes = formData?.variants?.[0]?.attributes;
      const notPriceAttrs = attributes?.filter(
        (attr) =>
          attr?.attribute_values_id?.attribute_id?.dtype != "price" ||
          (attr?.dtype ? attr?.dtype != "price" : "")
      );

      // const notPriceAttrs = attributes.filter(
      //   (attr) =>{
      //     if(
      //       attr?.attribute_values_id?.attribute_id?.name!== || attr?.dtype !== "price"){
      //       console.log("2--", attr?.attribute_values_id?.attribute_id?.name || attr?.name)
      //      }
      //   })

      //
      // );
      setSelectedAttrs(
        notPriceAttrs.map((attr) => {
          return attr?.attribute_values_id?.attribute_id?.id || attr?.id;
        })
      );

      setAttrsNames(
        attributes.map(
          (attr) => attr?.attribute_values_id?.attribute_id || attr
        )
      );
      setVariant(
        attributes.map(
          (attr) => attr?.attribute_values_id?.attribute_id || attr
        )
      );
      setVariantsData(formData?.variants);
    }
  }, [formData]);

  useEffect(() => {
    if (attributes) {
      const attrs = attributes?.attributes
        .filter(
          (field) =>
            field?.attributes_id?.tabname === "production" ||
            field?.attributes_id?.tabname === "production_detail" ||
            field?.tabname === "production" ||
            field?.tabname === "production_detail"
        )
        .filter((field) =>
          field?.dtype !== "price" || field?.attributes_id?.dtype
            ? field?.attributes_id?.dtype !== "price"
            : ""
        );
      setAttrs(attrs);
      const priceAttrs = attributes?.attributes.filter(
        (field) =>
          (field?.attributes_id?.tabname === "production" ||
            field?.tabname === "production") &&
          (field?.attributes_id?.dtype === "price" || field?.dtype === "price")
      );

      const sizeAttributes = attributes?.attributes.filter(
        (field) =>
          field?.attributes_id?.dtype === "size" || field?.dtype === "size"
      );

      setPriceAttrs(priceAttrs);
      setSizeAttrs(sizeAttributes);
    }
  }, [attributes]);

  const onChangeTags = (value) => {
    if (value.length > 0) {
      if (value.length > 3) {
        setSelectedAttrs([]);
        const selectedAttrsValue = attrs?.filter((attr) =>
          value?.includes(attr?.attributes_id?.id || attr?.id)
        );
        message.error("You can only select upto 3 options");
      } else {
        if (value) {
          setSelectedAttrs(value);
        }
        const selectedAttrsValue = attrs?.filter((attr) =>
          value?.includes(attr?.attributes_id?.id || attr?.id)
        );
        setAttrsNames(selectedAttrsValue);
      }
    } else {
      if (value) {
        setSelectedAttrs(value);
      }
      const selectedAttrsValue = attrs?.filter((attr) =>
        value?.includes(attr?.attributes_id?.id || attr?.id)
      );

      setAttrsNames(selectedAttrsValue);
    }
  };
  const save = () => {
    const selectedAttrsValue = attrs?.filter((attr) =>
      selectedAttrs?.includes(attr?.id)
    );
    const priceAttr = priceAttrs?.[0];

    const newData = {
      key: 0,
      [`${priceAttr?.name}:${priceAttr?.id}`]: [currency, "", unit],
    };

    setDataSource([newData]);
    setVariant([...selectedAttrsValue, ...priceAttrs]);
  };
  const handleDone = () => {
    // console.log("donecalled", v)
    const payload = dataSource.map((variant) => {
      // const priceName = priceAttrs?.[0]?.attributes_id?.name;
      // const priceField = priceName.toLowerCase().split(":")?.[0];
      let productVariant = Object.keys(variant).map((key) => {
        let attribute;

        const attributeId = key.split(":")?.[1];

        if (attributeId) {
          const name = key.toLowerCase().split(":")?.[0];
          const isPriceAttribute = priceAttrs?.filter(
            (item) =>
              item.attributes_id?.id?.toString() === attributeId ||
              item?.id?.toString() === attributeId
          ).length;

          // (item)=>console.log(item))
          //   (item) => (item.attributes_id.id.toString() === attributeId) || (item.id.toString() === attributeId)
          // ).length;
          const isSizeAttribute = sizeAttrs?.filter(
            (item) =>
              item.attributes_id?.id?.toString() === attributeId ||
              item?.id?.toString() === attributeId
          ).length;
          if (isPriceAttribute) {
            const price = variant[key]?.[1];
            const currency = variant[key]?.[0];
            const unit = variant[key]?.[2];
            attribute = {
              attribute_values_id: {
                attribute_id: attributeId,
                values: price,
                composite: {
                  currency: currency,
                  unit: unit,
                },
              },
            };
          } else if (isSizeAttribute) {
            if (key.split(":").length > 2) {
              return;
            }
            let sizeKey = `${key.split(":")?.[0]}:${key.split(":")?.[1]}`;
            const length = variant[sizeKey]?.[1];
            const width = variant[sizeKey]?.[2];
            const height = variant[sizeKey]?.[3];
            const value = variant[sizeKey]?.[0];
            const unit = variant[sizeKey]?.[4];
            attribute = {
              attribute_values_id: {
                attribute_id: attributeId,
                values: value,
                composite: {
                  height: height,
                  width: width,
                  length: length,
                  unit: unit,
                },
              },
            };
          } else {
            attribute = {
              attribute_values_id: {
                attribute_id: attributeId,
                values:
                  variant[key] && typeof variant[key] === "object"
                    ? variant[key].join(",")
                    : variant[key],
              },
            };
          }
        }
        return attribute;
      });
      const finalPayload = {
        attributes: productVariant.filter((attr) => attr),
        variant_id: variant?.variantId,
      };
      return finalPayload;
    });

    let validatepayload = payload.some((variant) => !variant.variant_id);
    if (validatepayload) {
      message.error("Please enter Variant ID");
    } else {
      handleOkVaraint(payload);
    }
  };

  function confirm(e) {
    save();
  }

  function cancel(e) {
    console.log(e);
    return;
  }

  console.log("selectedAttrs", selectedAttrs);
  return (
    <div>
      <Modal
        centered
        visible={showVariantModal}
        onOk={handleOkVaraint}
        // onCancel={handleCancelVariant}
        footer={null}
        width={"80%"}
        closable={false}
        closeIcon={null}
      >
        {/* Title start here */}
        <Row>
          <Col>
            <Title level={3}>Add Variants for {productId}</Title>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Text>
              Select the variant types manufactured for this product. You can
              select only upto 3 options{" "}
            </Text>
          </Col>
        </Row>
        {/* Title end here */}

        {/* Select start here */}
        <Row style={{ marginTop: "2em" }} justify="space-between">
          <Col span={18}>
            <Select
              placeholder="Click to view options"
              value={selectedAttrs}
              mode="multiple"
              size="large"
              style={{ width: "100%" }}
              onChange={(value) => onChangeTags(value)}
            >
              {attrs?.map((field) => (
                <Select.Option
                  key={field.attributes_id?.id || field?.id}
                  value={field.attributes_id?.id || field?.id}
                >
                  {field.attributes_id?.name || field?.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={4}>
            {selectedAttrs.length > 0 ? (
              <Popconfirm
                title={
                  <span>
                    All the added details will be lost. Wish to continue?
                    {/* for{" "}
                    {attrsNames.map((attr, index) => (
                      attr?.attributes_id?.dtype !== "price" && attr?.dtype !== "price" ? 
                      <b key={index}>
                        {attr?.attributes_id?.name || attr?.name}
                        {attrsNames.length - 1 === index ? "" : ", "}
                      </b>:null
                    ))}{" "} */}
                  </span>
                }
                icon={<WarningFilled style={{ fontSize: 16, color: "red" }} />}
                placement="left"
                onConfirm={confirm}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  disabled={selectedAttrs?.length > 0 ? false : true}
                  size="large"
                  type="primary"
                  style={{ width: "100%" }}
                >
                  Update
                </Button>
              </Popconfirm>
            ) : (
              <Button
                disabled={selectedAttrs?.length > 0 ? false : true}
                size="large"
                type="primary"
                style={{ width: "100%" }}
                onClick={save}
              >
                Confirm
              </Button>
            )}
          </Col>
        </Row>
        {/* Select end here */}

        {/* Table start here */}
        <Row style={{ marginTop: "2em", marginBottom: "1em" }}>
          <Col span={24}>
            <Text>Add details for all the variants available</Text>
          </Col>
        </Row>

        {variant?.length > 0 ? (
          <Table
            variant={variant}
            dataSource={dataSource}
            setDataSource={setDataSource}
            variantsData={variantsData}
            priceAttrs={priceAttrs}
            currency={currency}
            setCurrency={setCurrency}
            unit={unit}
            sizeUnit={sizeUnit}
            setUnit={setUnit}
            setSizeUnit={setSizeUnit}
          />
        ) : (
          <EmptyState />
        )}

        {/* Table end here */}
        <Divider />

        {/* action buttons starts here */}
        <Row justify="space-between" style={{ marginTop: "1em" }}>
          <Col span={4}>
            <Button
              size="large"
              style={{ width: "100%" }}
              onClick={handleCancelVariant}
            >
              Cancel
            </Button>
          </Col>
          <Col span={4}>
            <Button
              size="large"
              style={{
                width: "100%",
                background: variant?.length ? Colors.black : "#F5F5F5",
                color: variant?.length ? Colors.white : "lightgray",
                border: 0,
              }}
              onClick={() => {
                handleDone();
              }}
              disabled={variant?.length > 0 ? false : true}
            >
              Done
            </Button>
          </Col>
        </Row>
        {/* action buttons ends here */}
      </Modal>
    </div>
  );
}
